import { onMounted, ref } from 'vue';
import type { Ref } from 'vue';

import type { Country } from '@/features/destination';
import type { DepartureCity } from '@/features/departure-city';
import { clearSearchFormDataCache, getSearchFormData } from '../api/getSearchFormData';
import type { DefaultCriteriaIndex } from '../lib/defaultCriteria';

export interface UseSearchFormData {
  countries: Ref<Country[]>;
  cities: Ref<DepartureCity[]>;
  defaultCriteria: Ref<DefaultCriteriaIndex>;
  loading: Ref<boolean>;
}

export function useSearchFormData(): UseSearchFormData {
  const countries = ref<Country[]>([]);
  const cities = ref<DepartureCity[]>([]);
  const defaultCriteria = ref<DefaultCriteriaIndex>({});
  const loading = ref(false);

  const load = async (): Promise<void> => {
    loading.value = true;
    try {
      const data = await getSearchFormData();
      countries.value = data.countries;
      cities.value = data.cities;
      defaultCriteria.value = data.defaultCriteria;
    } finally {
      loading.value = false;
    }
  };

  onMounted(() => {
    void load();
  });

  return { countries, cities, defaultCriteria, loading };
}
